import { type Configuration, LogLevel } from '@azure/msal-browser';
import { config } from '../config';

/**
 * MSAL configuration for Azure AD authentication
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: config.azureAd.clientId,
    authority: config.azureAd.authority,
    redirectUri: config.azureAd.redirectUri,
  },
  cache: {
    cacheLocation: 'sessionStorage', // Use sessionStorage for better security
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

/**
 * Scopes for login
 * Using the default user.read scope for basic authentication
 */
export const loginRequest = {
  scopes: ['User.Read'],
};

/**
 * Scopes for API access
 * Request a token for our own API
 */
export const apiRequest = {
  scopes: [`api://${config.azureAd.clientId}/access_as_user`],
};
